import React from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import countyImage from "../../images/con-pvr-legend-county.png"
import Image from "material-ui-image";

const useStyles = makeStyles({

});

export default function LegendCounty2() {
  const classes = useStyles();

  return (
    <div>
      <div className="legendCounty">
        <Grid container>
        <Image src={countyImage} style={{padding: "115px", paddingTop: "145px", marginTop: "10px", backgroundColor: "transparent"}} disableTransition />
        </Grid>

      </div>
    </div>
  );
}